'use client';

import { Tab } from '@headlessui/react';
import type { Dictionary } from 'types/common';

import CompanyRegistrationForm from './companyRegistrationForm';
import UserRegistrationForm from './userRegistrationForm';

export default function RegistrationForms({
    dictionary,
}: {
    dictionary: Dictionary;
}) {
    return (
        <Tab.Group as="div" className="mt-6 md:mt-10">
            <Tab.List className="grid grid-cols-2 text-sm font-bold text-grey-300">
                <Tab className="border-b border-grey-150 p-2 ui-selected:border-current ui-selected:text-black">
                    {dictionary?.individual}
                </Tab>
                <Tab className="border-b border-grey-150 p-2 ui-selected:border-current ui-selected:text-black">
                    {dictionary?.company}
                </Tab>
            </Tab.List>
            <Tab.Panels className="mt-6">
                <Tab.Panel tabIndex={-1}>
                    <UserRegistrationForm dictionary={dictionary} />
                </Tab.Panel>
                <Tab.Panel tabIndex={-1}>
                    <CompanyRegistrationForm dictionary={dictionary} />
                </Tab.Panel>
            </Tab.Panels>
        </Tab.Group>
    );
}
